import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

import { RecoilRoot } from 'recoil';
import { ApolloProvider } from '@apollo/client';
import { initializeState } from 'state/initializeState';
import { client } from 'connectors/apollo';
import { StylesProvider } from '@material-ui/core/styles';

const render = (Component) =>
  ReactDOM.render(
    <ApolloProvider client={client}>
      <RecoilRoot initializeState={initializeState}>
        <StylesProvider injectFirst>
          <Router basename="/rma-manager">
            <Component />
          </Router>
        </StylesProvider>
      </RecoilRoot>
    </ApolloProvider>,
    document.getElementById('root')
  );

render(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    render(NextApp);
  });
}
